/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-decision': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11 5H8l4-4 4 4h-3v4.43c-.75.46-1.42 1.03-2 1.69V5m11 6l-4-4v3a6.747 6.747 0 00-7 6.17A3.006 3.006 0 009.17 20 3.006 3.006 0 0013 21.83 3.01 3.01 0 0014.83 18c-.3-.86-.98-1.53-1.83-1.83.47-4 4.47-4.2 4.95-4.2v3L22 11m-11.37.59A7.632 7.632 0 006 10V7l-4 4 4 4v-3c1.34.03 2.63.5 3.64 1.4.25-.64.58-1.25.99-1.81z"/>'
  }
})
